import { render } from "./Inspection.vue?vue&type=template&id=22f0dbf0&scoped=true&lang=pug"
import script from "./Inspection.vue?vue&type=script&lang=ts"
export * from "./Inspection.vue?vue&type=script&lang=ts"

import "./Inspection.vue?vue&type=style&index=0&id=22f0dbf0&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-22f0dbf0"

export default script